import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { encryption } from '../../../lib/encryption';
import { login } from '../../../services/authService';
import {setCookie} from 'cookies-next';
import { jwtDecode } from 'jwt-decode';

function Login() {
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState('')
	const [isLoading, setIsLoading] = useState(false)
	const router =useHistory()
	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		setIsLoading(true);

		try {
			const data = await login(username, password);
			if (data.result) {
				const decoded = jwtDecode(data.result);
				// Lưu token vào cookie thay vì localStorage
				setCookie('auth-token', encryption(data.result), {
					maxAge: 60 * 60 * 24 * 7, // 1 tuần
					path: '/',
					secure: process.env.NODE_ENV === 'production',
					sameSite: 'strict'
				});
				setCookie('user', encryption(JSON.stringify(decoded)), {
					maxAge: 60 * 60 * 24 * 7, // 1 tuần
					path: '/',
					secure: process.env.NODE_ENV === 'production',
					sameSite: 'strict'
				});
				router.push('/courses');
			}
		} catch (error) {
			setError("Có lỗi xảy ra khi đăng nhập!");
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<div className="min-h-screen flex items-center justify-center shadow-xl/30">
			<div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
				<h1 className="text-2xl font-bold text-center text-gray-800 mb-8">ĐĂNG NHẬP</h1>
				{error && (
					<div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md text-sm">
						{error}
					</div>
				)}

				<form onSubmit={handleSubmit} className="space-y-4">
					<div>
						<label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
							Tên đăng nhập
						</label>
						<input
							id="username"
							type="text"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
							required
						/>
					</div>

					<div>
						<label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
							Mật khẩu
						</label>
						<input
							id="password"
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
							required
						/>
					</div>

					<button
						type="submit"
						className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
					>
						{isLoading ? "Đang xử lý..." : "Đăng nhập"}
					</button>
				</form>
			</div>
		</div>
	)
}

export default Login;
